import { PrismicPageParser } from "../../shared/utils/prismicPageParser"
import cx from "classnames"
import styles from "./ArtistCollabsContainer.module.scss"

const ArtistCollabsContainer = () => {
  const data = JSON.parse(window.prismic_data)
  const pageId = window.pageId

  return (
    <section
      id="mm-artist-collabs"
      className={cx(styles.collabs, "pageContainer")}
      aria-label="Artist Collaborations"
    >
      <PrismicPageParser pageData={data} pageId={pageId} />
    </section>
  )
}

export default ArtistCollabsContainer
